<script setup>
import { initializeWindowEvents } from '@/composables/helpers/layouts/window'
import { updateGlobals } from '@/composables/data/updateGlobals'
import Hero from '~/components/blocks/two-six/hero.vue';
import errorHeroImg from '@/assets/img/2026/error-hero.jpg';

const { data: global } = await useAsyncData('all-global-data', () => $fetch('/api/global-data'))

await updateGlobals(unref(global))
initializeWindowEvents()

const props = defineProps({
    error: Object
})

const heroProps = computed(() => ({
    headline: props.error.statusCode === 404
        ? 'Sorry, this space is empty!'
        : 'Oops!',
    copy: props.error.statusCode === 404
        ? "Something went wrong and we can't find the page that you're looking for."
        : "Sorry, something went wrong and we couldn't process that request.",
    button: {
        label: 'Go Back Home',
        title: 'Navigate to the home page',
        url: '/',
    },
    video: {
        video: '',
        poster: errorHeroImg,
        altText: 'Empty conference hall',
    },
}))

const page = ref({
    id: 'error-page',
    model: 'error-page',
    data: {
        title: `${props.error.statusCode} error page`
    }
})

const handleError = () => clearError({ redirect: '/' });

// Clear error state on any navigation away
const route = useRoute();
watch(() => route.fullPath, () => {
    clearError();
});
</script>

<template>
    <NuxtLayout name="error">
        <ProjectPage :page="page">
            <Hero v-bind="heroProps" @click.capture="handleError" />
        </ProjectPage>
    </NuxtLayout>
</template>

<style>
[data-model="error-page"] .root-container {
    display: flex;
    flex-direction: column;
}

[data-model="error-page"] .mess-page {
    display: flex;
    flex-direction: column;
    flex: 1;
}

[data-model="error-page"] .block-2026-hero {
    flex: 1;
}
</style>
